import React from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import { Alert } from 'componentLibrary';
import _ from 'lodash';

/* DEFUNCT, dont use! */
export class DynamicAlert extends React.Component {
  render = () => {
    const {alertHeader, alertType, dynamicComponent, dataPath} = this.props;

    let errors = [];
    _.forEach(dataPath, (path) => {
      errors.push(<p key={path}>{_.get(dynamicComponent, path)}</p>);
    });

    const content = !_.isEmpty(errors) ? (
      <React.Fragment>{errors}</React.Fragment>
    ) : (
      this.props.content
    );

    return (
      <Alert type={alertType} header={alertHeader} paragraph={false}>
        {content}
      </Alert>
    );
  };
}

export default connectDynamic(DynamicAlert);
